// BAK

// prohazovani funkce, textu a tridy na rozbalovacim/sbalovacim odkazu
function filterLinkMore() {
    const lessFilters = document.querySelectorAll('.less-filter');
    if (lessFilters.length > 0) {
        lessFilters.forEach(lessFilter => {
            lessFilter.setAttribute('onclick', 'filterShow()');
            lessFilter.textContent = lessFilter.getAttribute('rel');
            lessFilter.classList.remove('less-filter');
            lessFilter.classList.add('more-filter');
            lessFilter.setAttribute('aria-expanded', 'false');
        });
    }
}

function filterLinkLess() {
    const moreFilters = document.querySelectorAll('.more-filter');
    if (moreFilters.length > 0) {
        moreFilters.forEach(moreFilter => {
            moreFilter.setAttribute('onclick', 'filterHide()');
            moreFilter.textContent = moreFilter.getAttribute('rev');
            moreFilter.classList.remove('more-filter');
            moreFilter.classList.add('less-filter');
            moreFilter.setAttribute('aria-expanded', 'true');
        });
    }
}

function paginationFilterOn() {
    const form = document.getElementById('checkGotoPage');
    if (form !== null && form.action.indexOf('#filterToggleBox') === -1) {
        form.action += '#filterToggleBox';
    }

    const links = document.querySelectorAll('.pagination a');
    links.forEach(link => {
        const href = link.href;
        if (href.indexOf('#filterToggleBox') === -1) {
            link.href += '#filterToggleBox';
        }
    });
}

// rozbaleni a sbaleni filtru produktu u kategorie eshopu
let filterLoaded = 0;

function loadFilter(delkaod, delkado, sirkaod, sirkado, skladem) {
    const url = '/ajax/filter/?delkaod=' + delkaod + '&delkado=' + delkado + '&sirkaod=' + sirkaod + '&sirkado=' + sirkado + '&skladem=' + skladem,
        // body = '',
        querySelector = '#filterToggleBox',
        // position = 'beforeend',
        fnAfter = 'loadFilterAfter';

    loadData(url, '', querySelector, '', fnAfter);
}

function loadFilterAfter() {
    filterLinkLess();
    filterLoaded = 1;

    const form = document.getElementById('filterForm');
    form.action = category_url + '#filterToggleBox';
};

function filterShow(delkaod, delkado, sirkaod, sirkado, skladem) {
    if (filterLoaded !== 1) {
        const filterToggleBox = document.getElementById('filterToggleBox');
        if (filterToggleBox) {
            loadFilter(delkaod, delkado, sirkaod, sirkado, skladem);
        }
    } else {
        const filterElements = document.querySelectorAll('#filterToggleBox .filter');
        if (filterElements.length > 0) {
            filterElements.forEach(filterElement => {
                filterElement.style.display = 'block';
            });
            filterLinkLess();
        }
    }
}

function filterHide() {
    const filterElements = document.querySelectorAll('#filterToggleBox .filter');
    if (filterElements.length > 0) {
        filterElements.forEach(filterElement => {
            filterElement.style.display = 'none';
        });
        filterLinkMore();
    }
}

// rozbalovani filtru pri prichodu pres odkaz s kotvou
document.addEventListener('DOMContentLoaded', function() {
    var hash = window.location.hash;
    if (hash == '#filterToggleBox') {
        var $_GET = {};
        document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function() {
            function decode(s) {
                return decodeURIComponent(s.split("+").join(" "));
            }

            $_GET[decode(arguments[1])] = decode(arguments[2]);
        });
        if ($_GET["delkaod"] || $_GET["delkado"] || $_GET["sirkaod"] || $_GET["sirkado"] || ($_GET["skladem"] && $_GET["skladem"] != '0')) {
            filterShow($_GET["delkaod"], $_GET["delkado"], $_GET["sirkaod"], $_GET["sirkado"], $_GET["skladem"]);
            paginationFilterOn();
        }
    }
});

// rozbaleni a sbaleni doplnkovych poli formulare
document.addEventListener('DOMContentLoaded', () => {
    const controls = document.querySelectorAll('.form-block-control:not(.form-block-control--ready)');

    controls.forEach((control) => {
        const toggleLink = control.querySelector('a, button'); // Good to remove "a" after c2a forms update
        if (!toggleLink) return;

        const formBlockId = toggleLink.dataset.formBlockId; // Get the related form-block ID
        if (!formBlockId) return;

        const relatedFormBlock = document.getElementById(formBlockId); // Find the related form-block
        if (!relatedFormBlock) return;

        const relText = toggleLink.getAttribute('rel');
        const revText = toggleLink.getAttribute('rev');
        if (!relText || !revText) return;

        toggleLink.textContent = relText;
        control.classList.add('form-block-control--ready');

        toggleLink.addEventListener('click', (event) => {
            event.preventDefault();

            // Toggle visibility classes on the form block and control
            const isHidden = relatedFormBlock.classList.contains('form-block--hidden');
            relatedFormBlock.classList.toggle('form-block--hidden', !isHidden);
            relatedFormBlock.classList.toggle('form-block--shown', isHidden);

            control.classList.toggle('form-block--is-hidden', !isHidden);
            control.classList.toggle('form-block--is-shown', isHidden);

            // Update the toggle link text
            toggleLink.textContent = isHidden ? revText : relText;
            // Update the toggle link aria-expanded value
            toggleLink.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        });
    });
});


// vklada tooltip se seznamem neomezenych zemi do hlasky
function loadCountriesTooltip() {
    const url = '/ajax/unlimited-countries-list-tooltip/',
        // body = '',
        querySelector = '#unlimited-countries-list',
        // position = 'beforeend',
        fnAfter = 'tooltipControl';

    loadData(url, '', querySelector, '', fnAfter);
}

function displayCountriesTooltip() {
    const unlimitedCountriesList = document.getElementById('unlimited-countries-list');
    if (unlimitedCountriesList) {
        loadCountriesTooltip();
    }
}

// vklada jmeno pasu do poptavkoveho formulare (kategorie Ploche remeny a pasy > .. > Dopravni pasy z PVC, Dopravni pasy z polyuretanu, RAPPLON)
document.querySelectorAll('.but--onclick-name4input').forEach(function(button) {
    button.addEventListener('click', function(e) {
        document.querySelector('input#aplikace').setAttribute('value', this.getAttribute('data-name4input'));
    });
});

// nahraje náhledy obrázků v galerii (po nahrání hlavního náhledu)
function displayGalleryBox() {
    var el = document.querySelector('.product-gallery__box');
    if (el) {
        el.style.display = 'flex';
    }
}

function thnLoadTrigger() {
    var thn = document.querySelector('.product-img__thn');
    if (thn) {

        if (thn.naturalHeight !== 0) {
            displayGalleryBox();
        } else {
            thn.addEventListener(
                'load',
                function() {
                    displayGalleryBox();
                }
            );
        }
    }
}

thnLoadTrigger();